import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { Button } from '@/shared/components/ui/button';
export function BuiltWith() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button asChild={true} variant="outline" size="sm" className="hover:bg-primary/10"><Link href="https://shipany.ai" target="_blank">Built with ❤️ ShipAny</Link></Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}